import classNames from 'classnames';
import { formatMediaTime } from 'src/utils/playerUtils';
import styles from './styles.module.scss';

export type TextTimeProps = {
  time: number;
  className?: string;
};

const TextTime = ({ time, className }: TextTimeProps) => {
  return <span className={classNames(styles.textTime, className)}>{formatMediaTime(Math.round(time))}</span>;
};
export default TextTime;
